{
  "aliases": {
    "en": "english",
    "english": "english",
    "es": "spanish",
    "spanish": "spanish",
    "español": "spanish",
    "castellano": "spanish",
    "fr": "french",
    "french": "french",
    "français": "french",
    "de": "german",
    "german": "german",
    "deutsch": "german",
    "pt": "portuguese",
    "portuguese": "portuguese",
    "português": "portuguese",
    "it": "italian",
    "italian": "italian",
    "italiano": "italian",
    "nl": "dutch",
    "dutch": "dutch",
    "nederlands": "dutch",
    "zh": "chinese",
    "chinese": "chinese",
    "mandarin": "chinese",
    "cantonese": "chinese",
    "traditional chinese": "chinese",
    "simplified chinese": "chinese",
    "中文": "chinese",
    "ja": "japanese",
    "japanese": "japanese",
    "日本語": "japanese",
    "ko": "korean",
    "korean": "korean",
    "한국어": "korean",
    "ru": "russian",
    "russian": "russian",
    "ukrainian": "ukrainian",
    "bulgarian": "bulgarian",
    "ar": "arabic",
    "arabic": "arabic",
    "he": "hebrew",
    "hebrew": "hebrew",
    "th": "thai",
    "thai": "thai",
    "el": "greek",
    "greek": "greek",
    "hi": "hindi",
    "hindi": "hindi"
  },
  "displayNames": {
    "english": "English",
    "spanish": "Spanish",
    "french": "French",
    "german": "German",
    "portuguese": "Portuguese",
    "italian": "Italian",
    "dutch": "Dutch",
    "chinese": "Chinese",
    "japanese": "Japanese",
    "korean": "Korean",
    "russian": "Russian",
    "ukrainian": "Ukrainian",
    "bulgarian": "Bulgarian",
    "arabic": "Arabic",
    "hebrew": "Hebrew",
    "thai": "Thai",
    "greek": "Greek",
    "hindi": "Hindi"
  },
  "scripts": {
    "english": "latin",
    "spanish": "latin",
    "french": "latin",
    "german": "latin",
    "portuguese": "latin",
    "italian": "latin",
    "dutch": "latin",
    "ukrainian": "cyrillic",
    "bulgarian": "cyrillic",
    "russian": "cyrillic",
    "chinese": "han",
    "japanese": "japanese",
    "korean": "hangul",
    "arabic": "arabic",
    "hebrew": "hebrew",
    "thai": "thai",
    "greek": "greek",
    "hindi": "devanagari"
  },
  "words": {
    "english": ["the", "and", "you", "your", "this", "that", "with", "from", "have", "would", "could", "please", "thanks", "thank", "about", "what", "email", "message", "reply", "hello", "should", "because", "which", "for", "are", "was", "meeting", "invoice"],
    "spanish": ["hola", "gracias", "usted", "ustedes", "porque", "también", "está", "están", "mensaje", "correo", "para", "señor", "señora", "mañana", "necesito", "puedes", "puede", "actualización", "buenos", "días"],
    "french": ["bonjour", "merci", "vous", "nous", "pour", "avec", "cette", "dans", "pouvez", "veuillez", "cordialement", "cest", "votre", "nous", "pas", "je"],
    "german": ["danke", "bitte", "nicht", "und", "für", "eine", "nachricht", "können", "ihnen", "grüße", "hallo", "ihre", "dass"],
    "portuguese": ["você", "obrigado", "obrigada", "não", "mensagem", "olá", "preciso", "você"],
    "italian": ["grazie", "ciao", "buongiorno", "messaggio", "questa", "perché", "sono", "buonasera", "prego", "puoi"],
    "dutch": ["niet", "dank", "alstublieft", "bericht", "geen", "maar", "voor", "kunt", "groeten"]
  },
  "phrases": {
    "english": ["thank you", "let me know", "please reply"],
    "spanish": ["por favor", "buenos días", "muchas gracias"],
    "french": ["s'il vous plaît", "cordialement"],
    "german": ["mit freundlichen", "vielen dank"],
    "portuguese": ["obrigado", "por favor"],
    "italian": ["per favore", "grazie mille"],
    "dutch": ["dank u", "met vriendelijke"]
  }
}
